import { NEW_VERSION_URL } from "./old-version-notice";
import { getSwUsernameFromToken, isAllowedV1 } from "./v1-allowlist";

// Giao diện cũ đã đóng: mọi lần tải trang đều bị đẩy sang V2, trừ các swUsername
// nằm trong V1_ALLOWED_USERS (xem lib/v1-allowlist.js).
// Trả về true khi đã redirect, để caller không bootstrap app nữa.
export function redirectToV2() {
  // Đang ở sẵn /v2 (vd SPA fallback trả về chính app này) -> dừng, tránh loop vô hạn.
  if (window.location.pathname.indexOf("/v2") === 0) return false;
  if (isAllowedV1(getSwUsernameFromToken())) return false;
  window.location.replace(NEW_VERSION_URL + window.location.search + window.location.hash);
  return true;
}
